import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["auth.token"],
  (action: any): any => action
);
